
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
//import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import router from "@/router";
import {UserAuth} from "@/models/UserAuth";
import { GlobalService } from "@/services/GlobalService";


@Component({
  name: "PerfilUsuario",
})

export default class PerfilUsuario extends Vue {
  @Prop() usuarioEdit!: any
  @Prop() dialog!: boolean

  private globalStore = globalStore();
	private globalService = GlobalService.getInstance();
  private consultorioStore = useConsultorioStore();
  private consultorioService = consultorioService.getInstance();
  private tab:any = null;
  
  usuario_seleccionado = '';
  
  usuario= {
      id: null,
      name: '',
      email: '',
      nombre_consultorio: '',
      color_header: '',
  }
	password = '';
	password_repeated = '';
  valid = true;
  fecha = DateTime.now().toFormat('yyyy-MM-dd');
  get user(): UserAuth {
    return this.globalStore.user;
  }
  mounted(){
    //this.getTratamientos();
	this.cargarDatos();
  }
  
  guardar(){
    if (!this.$refs.form.validate()) {
      Alert.warning( `Llene todos los campos obligatorios (*)`)
        return;
		}
		Alert.confirm(`Se actualizaran los datos del usuario ${this.usuario.name} `, 'Actualizar datos?').then(async result => {
			if(result.isConfirmed){
				await this.consultorioService.actualizarUsuario(this.usuario).then(response =>{
					//this.limpiar()
					//router.push({name: 'pacientes'});
				})
			}
		})
	}
	modificarPassword() {
		if(this.password.length < 8 ) {
			Alert.warning("El password debe tener al menos 8 caracteres")
			return;
		}
		if(this.password !== this.password_repeated){
			Alert.warning("Los passwords no coinciden");
			return;
		}

		const data = {
			user_id: this.user.id,
			password: this.password
		}
		Alert.confirm(`Se modificara el password del usuario ${this.usuario.name} `, 'Modificar password?').then(async result => {
			if(result.isConfirmed){
				this.consultorioService.modificarPassword(data).then(response => {
					this.salirDelSistema();
				})
			}
		})
		
	}
	salirDelSistema() {
    this.globalService.destroyToken().then(() => {
      //window.location.href = this.urlYakusela;
      this.$router.push({name: 'login'});
    })
  }
  

  limpiar(){
    this.usuario= {
      id: null,
      name: '',
      email: '',
      nombre_consultorio: '',
      color_header: '',
    }
  }
	cargarDatos() {
		this.usuario.id = this.user.id;
		this.usuario.name = this.user.name;
		this.usuario.email = this.user.email;

	}
  get loading(): boolean {
    return this.consultorioStore.loading;
  }
}

